module.exports = __webpack_public_path__ + "img/promo2.a4c08e33.jpg";